import { memo } from "react";

function IconLogo_DEVA() {
  return (
    <svg
      width="99"
      height="26"
      viewBox="0 0 99 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_198_423)">
        <path
          d="M85.3585 23.6671L82.9089 19.4813C82.5835 18.9253 82.9845 18.2261 83.6286 18.2261H88.528C89.1722 18.2261 89.5731 18.9253 89.2478 19.4813L86.798 23.6671C86.476 24.2174 85.6806 24.2174 85.3585 23.6671Z"
          fill="#00C7B1"
        />
        <path
          d="M69.8723 9.15527e-05C69.6255 9.15527e-05 69.4062 0.157492 69.3274 0.391392L62.8963 19.4561C62.6922 20.061 62.202 20.1514 61.9279 20.1514C61.6536 20.1514 61.1634 20.0612 60.9593 19.4561L54.5263 0.391292C54.4474 0.157492 54.2281 9.15527e-05 53.9813 9.15527e-05H49.4977C49.1042 9.15527e-05 48.827 0.386292 48.9528 0.759092L55.8443 21.182C56.9691 24.5159 60.4506 26.3675 64.1456 25.1981C65.94 24.6304 67.3311 23.1984 67.9327 21.4151L74.9005 0.759092C75.0262 0.386192 74.749 9.15527e-05 74.3555 9.15527e-05H69.8723Z"
          fill="#041C2C"
        />
        <path
          d="M78.1829 25.4509C78.4297 25.4509 78.649 25.2934 78.7278 25.0596L85.0923 6.19243C85.2964 5.58723 85.7867 5.49693 86.0608 5.49693C86.3349 5.49693 86.8252 5.58723 87.0293 6.19243L93.396 25.0596C93.4749 25.2935 93.6942 25.4509 93.941 25.4509H98.4244C98.8179 25.4509 99.0952 25.0647 98.9693 24.6918L92.1443 4.46623C91.249 1.81283 88.8609 0.0984328 86.0606 0.0986328C83.2601 0.0988328 80.8724 1.81343 79.9772 4.46703L73.1547 24.6919C73.0289 25.0647 73.3062 25.4509 73.6997 25.4509H78.1829Z"
          fill="#041C2C"
        />
        <path
          d="M44.3693 5.1152H27.1329C26.8145 5.1152 26.5564 4.8571 26.5564 4.5387V0.5764C26.5564 0.2581 26.8145 0 27.1329 0H44.3693C44.6881 0 44.9467 0.2585 44.9467 0.5773V4.5379C44.9467 4.8567 44.6881 5.1152 44.3693 5.1152Z"
          fill="#041C2C"
        />
        <path
          d="M44.3693 25.5493H27.1329C26.8145 25.5493 26.5564 25.2912 26.5564 24.9728V21.0105C26.5564 20.6922 26.8145 20.4341 27.1329 20.4341H44.3693C44.6881 20.4341 44.9467 20.6926 44.9467 21.0114V24.972C44.9467 25.2908 44.6881 25.5493 44.3693 25.5493Z"
          fill="#041C2C"
        />
        <path
          d="M44.3693 15.3325H27.1329C26.8145 15.3325 26.5564 15.0744 26.5564 14.756V10.7937C26.5564 10.4754 26.8145 10.2173 27.1329 10.2173H44.3693C44.6881 10.2173 44.9467 10.4758 44.9467 10.7946V14.7552C44.9467 15.074 44.6881 15.3325 44.3693 15.3325Z"
          fill="#041C2C"
        />
        <path
          d="M3.5404 25.5493C2.4941 25.5493 1.64245 25.233 0.985472 24.6003C0.328491 23.9677 0 23.1404 0 22.1184V0H12.1907C14.1373 0 15.8406 0.36499 17.3005 1.09497C18.7848 1.82495 19.9284 2.85909 20.7314 4.19738C21.5587 5.53568 21.9724 7.0808 21.9724 8.83275V15.9866C21.9724 19.1255 21.1572 21.5101 19.527 23.1404C17.8967 24.7463 15.4999 25.5493 12.3367 25.5493H3.5404ZM12.1907 21.0964C13.7479 21.0964 14.9281 20.6463 15.7311 19.7459C16.534 18.8456 16.9355 17.5195 16.9355 15.7676V9.05175C16.9355 7.66479 16.4854 6.55765 15.5851 5.73034C14.6848 4.8787 13.5046 4.45288 12.0447 4.45288H5.03686V21.0964H12.1907Z"
          fill="url(#paint0_linear_198_423)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_198_423"
          x1="0"
          y1="12.7746"
          x2="21.9724"
          y2="12.7746"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF5252" />
          <stop offset="1" stopColor="#041C2C" />
        </linearGradient>
        <clipPath id="clip0_198_423">
          <rect width="99" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default memo(IconLogo_DEVA);
